<template>
    <v-app v-if="show" class="default-layout">
        <ProgressBar />
        <MainNotifications />
        <SideNav :getMyyInfo="this.userInfo" />
        <v-main class="default-layout__main">
            <router-view />
        </v-main>
    </v-app>
</template>

<script>
import ProgressBar from '@/components/Core/ProgressBar.vue';
import MainNotifications from '@/components/Core/MainNotifications.vue';
import SideNav from '@/components/Navigation/SideNav.vue';

export default {
    name: 'default-layout',
    components: {
        ProgressBar,
        MainNotifications,
        SideNav
    },
    data() {
        return {
            show: false
        };
    },
    computed: {
        userInfo() {
            return this.$store.getters['authentication/getUserInfo'];
        }
    },
    watch: {
        $route() {
            window.scrollTo(0, 0);
        },
        userInfo(to) {
            if (to) {
                this.setUserInfo(to);
            }
        }
    },
    methods: {
        getData() {
            if (!this.userInfo) {
                const config = {
                    params: { appends: ['role', 'permissions', 'merchant'] }
                };

                this.$store.dispatch('authentication/fetchUserInfo', { config: config });
            } else {
                this.setUserInfo(this.userInfo);
            }
            window.scrollTo(0, 0);
        },
        setUserInfo(data) {
            this.$cookies.set('user-info', window.btoa(JSON.stringify(data))); // Encode To Base64
            this.show = true;
        }
    },
    created() {
        this.getData();
    }
};
</script>
